/* eslint-disable react/jsx-filename-extension */
import "./polyfills"; // MUST be first — adds ES2023 array methods missing on Chrome 109 (mui-tel-input toSorted)
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import ThemeProvider from "./components/ThemeProvider";
import App from "./routes";
import configureStore, { history } from "./store";
import DateUtilsProvider from "./components/DateUtilsProvider";
// import * as serviceWorker from './serviceWorker';
import { withLocalStorage } from "./utils/localStorageStore";
import NewVersionNotice from "./components/NewVersionNotice";
import { versionWatcher } from "./utils/appVersion";


const store = withLocalStorage(configureStore());


// React 18: ReactDOM.render → createRoot. Root is created once
// (idempotent re-render via root.render in HMR / re-init flow).
let root;

const renderApp = (AppComponent) => {
  if (!root) root = createRoot(document.getElementById("root"));
  root.render(
    <DateUtilsProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider>
          <Provider store={store}>
            <AppComponent history={history} />
            <NewVersionNotice />
          </Provider>
        </ThemeProvider>
      </StyledEngineProvider>
    </DateUtilsProvider>
  );
};

renderApp(App);
// Tells a tab left open across a deploy that a newer build is out (CREW-1289).
versionWatcher.start();

// Hot Module Replacement API — Vite's import.meta.hot replaces
// CRA/webpack's module.hot. The fallback for `module` lets the file
// keep loading under whatever transform doesn't recognize the meta
// (some test environments).
if (import.meta.hot) {
  import.meta.hot.accept("./routes.jsx", (mod) => {
    if (mod) renderApp(mod.default);
  });
}

// serviceWorker.register();
